import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SettingsButton } from "@/components/SettingsButton";

export function TopBar({ title, subtitle, showBack = false, right = null, showSettings = true }) {
  const navigate = useNavigate();
  const gear = !showBack && showSettings ? <SettingsButton /> : null;
  const rightSlot = (right || gear) ? (
    <div className="flex items-center -mr-1">
      {right}
      {gear}
    </div>
  ) : null;
  return (
    <header
      data-testid="top-bar"
      className="sticky top-0 z-30 bg-background/85 backdrop-blur-md pt-safe"
    >
      <div className="relative h-[56px] flex items-center px-4">
        {showBack && (
          <button
            data-testid="top-bar-back"
            onClick={() => navigate(-1)}
            className="absolute left-3 w-10 h-10 -ml-2 flex items-center justify-center text-muted-foreground tap"
          >
            <ChevronLeft className="w-6 h-6" strokeWidth={1.7} />
          </button>
        )}
        <div className="flex-1 text-center px-12">
          <h1 className="font-display text-[17px] font-medium tracking-tight text-foreground leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[11px] text-muted-foreground tracking-wide -mt-0.5">
              {subtitle}
            </p>
          )}
        </div>
        {rightSlot && <div className="absolute right-3 flex items-center">{rightSlot}</div>}
      </div>
    </header>
  );
}
